// ═══════════════ NSW TOLL ROADS DATABASE ═══════════════
// Current toll rates for NSW roads (2026 prices, updated quarterly)
// Rates are for Class A vehicles (cars, motorcycles, light commercial)
// All prices in AUD, inclusive of GST

const NSW_TOLLS = [
  {
    id: 'harbour_bridge',
    name: 'Sydney Harbour Bridge',
    direction: 'southbound', // Toll only going south (into city)
    peakRate: 4.00,
    offPeakRate: 3.00,
    weekendRate: 3.00,
    peakHours: { start: '06:30', end: '09:30' }, // AM peak
    peakHours2: { start: '16:00', end: '19:00' }, // PM peak
    coordinates: { lat: -33.8523, lng: 151.2108 },
    radius: 800, // meters — detection zone
  },
  {
    id: 'harbour_tunnel',
    name: 'Sydney Harbour Tunnel',
    direction: 'southbound',
    peakRate: 4.00,
    offPeakRate: 3.00,
    weekendRate: 3.00,
    peakHours: { start: '06:30', end: '09:30' },
    peakHours2: { start: '16:00', end: '19:00' },
    coordinates: { lat: -33.8560, lng: 151.2150 },
    radius: 600,
  },
  {
    id: 'eastern_distributor',
    name: 'Eastern Distributor',
    direction: 'northbound',
    peakRate: 8.95,
    offPeakRate: 6.72,
    weekendRate: 6.72,
    peakHours: { start: '06:30', end: '09:30' },
    peakHours2: { start: '16:00', end: '19:00' },
    coordinates: { lat: -33.8750, lng: 151.2150 },
    radius: 1000,
  },
  {
    id: 'cross_city_tunnel',
    name: 'Cross City Tunnel',
    direction: 'both',
    peakRate: 6.72,
    offPeakRate: 6.72,
    weekendRate: 6.72,
    peakHours: null,
    coordinates: { lat: -33.8720, lng: 151.2080 },
    radius: 800,
  },
  {
    id: 'lane_cove_tunnel',
    name: 'Lane Cove Tunnel',
    direction: 'westbound',
    peakRate: 4.14,
    offPeakRate: 3.10,
    weekendRate: 3.10,
    peakHours: { start: '06:30', end: '09:30' },
    peakHours2: { start: '16:00', end: '19:00' },
    coordinates: { lat: -33.8120, lng: 151.1520 },
    radius: 1000,
  },
  {
    id: 'm2',
    name: 'M2 Motorway (Hills M2)',
    direction: 'both',
    peakRate: 8.51,
    offPeakRate: 5.52,
    weekendRate: 4.25,
    peakHours: { start: '06:30', end: '09:30' },
    peakHours2: { start: '16:00', end: '19:00' },
    coordinates: { lat: -33.7750, lng: 151.0800 },
    radius: 2000,
  },
  {
    id: 'm4',
    name: 'M4 Motorway (WestConnex)',
    direction: 'both',
    peakRate: 9.09,
    offPeakRate: 7.28,
    weekendRate: 7.28,
    peakHours: { start: '06:30', end: '09:30' },
    peakHours2: { start: '16:00', end: '19:00' },
    coordinates: { lat: -33.8670, lng: 151.0400 },
    radius: 2000,
  },
  {
    id: 'm5_east',
    name: 'M5 East',
    direction: 'both',
    peakRate: 8.02,
    offPeakRate: 6.42,
    weekendRate: 6.42,
    peakHours: { start: '06:30', end: '09:30' },
    peakHours2: { start: '16:00', end: '19:00' },
    coordinates: { lat: -33.9450, lng: 151.1300 },
    radius: 2000,
  },
  {
    id: 'm5_southwest',
    name: 'M5 South West Motorway',
    direction: 'both',
    peakRate: 5.72,
    offPeakRate: 4.57,
    weekendRate: 4.57,
    peakHours: { start: '06:30', end: '09:30' },
    peakHours2: { start: '16:00', end: '19:00' },
    coordinates: { lat: -33.9600, lng: 150.9500 },
    radius: 3000,
  },
  {
    id: 'm7',
    name: 'M7 Motorway (Westlink)',
    direction: 'both',
    peakRate: 8.94,
    offPeakRate: 7.15,
    weekendRate: 7.15,
    peakHours: { start: '06:30', end: '09:30' },
    peakHours2: { start: '16:00', end: '19:00' },
    coordinates: { lat: -33.8300, lng: 150.9200 },
    radius: 4000,
  },
  {
    id: 'm8',
    name: 'M8 Motorway (WestConnex)',
    direction: 'both',
    peakRate: 8.02,
    offPeakRate: 6.42,
    weekendRate: 6.42,
    peakHours: { start: '06:30', end: '09:30' },
    peakHours2: { start: '16:00', end: '19:00' },
    coordinates: { lat: -33.9200, lng: 151.1700 },
    radius: 2000,
  },
  {
    id: 'm4_m5_link',
    name: 'M4-M5 Link (WestConnex)',
    direction: 'both',
    peakRate: 7.48,
    offPeakRate: 5.98,
    weekendRate: 5.98,
    peakHours: { start: '06:30', end: '09:30' },
    peakHours2: { start: '16:00', end: '19:00' },
    coordinates: { lat: -33.8900, lng: 151.1600 },
    radius: 2000,
  },
  {
    id: 'northconnex',
    name: 'NorthConnex',
    direction: 'both',
    peakRate: 8.95,
    offPeakRate: 6.72,
    weekendRate: 6.72,
    peakHours: { start: '06:30', end: '09:30' },
    peakHours2: { start: '16:00', end: '19:00' },
    coordinates: { lat: -33.7400, lng: 151.0900 },
    radius: 3000,
  },
];

// ═══════════════ TOLL CALCULATION HELPERS ═══════════════

function isTollPeakTime(pickupTime, toll) {
  if (!toll.peakHours) return false;
  const day = pickupTime.getDay();
  if (day === 0 || day === 6) return false; // Weekend = off-peak

  const timeStr = String(pickupTime.getHours()).padStart(2, '0') + ':' +
    String(pickupTime.getMinutes()).padStart(2, '0');

  if (timeStr >= toll.peakHours.start && timeStr <= toll.peakHours.end) return true;
  if (toll.peakHours2 && timeStr >= toll.peakHours2.start && timeStr <= toll.peakHours2.end) return true;
  return false;
}

function isWeekend(pickupTime) {
  const day = pickupTime.getDay();
  return day === 0 || day === 6;
}

function getTollRate(toll, pickupTime) {
  if (isWeekend(pickupTime)) return toll.weekendRate;
  if (isTollPeakTime(pickupTime, toll)) return toll.peakRate;
  return toll.offPeakRate;
}

function haversineDistance(lat1, lng1, lat2, lng2) {
  const R = 6371000; // Earth radius in meters
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

// ═══════════════ DETECT TOLLS ON ROUTE ═══════════════
// Uses Google Directions API to get the route path, then checks
// if any toll road coordinates fall within the route corridor

export async function detectTollsOnRoute(pickup, destination, pickupTime) {
  if (!window.google) return { tolls: [], totalToll: 0 };

  return new Promise((resolve) => {
    const directionsService = new window.google.maps.DirectionsService();

    directionsService.route({
      origin: { lat: pickup.lat, lng: pickup.lng },
      destination: { lat: destination.lat, lng: destination.lng },
      travelMode: 'DRIVING',
      drivingOptions: {
        departureTime: pickupTime > new Date() ? pickupTime : new Date(),
        trafficModel: 'bestguess',
      },
      provideRouteAlternatives: true,
    }, (response, status) => {
      if (status !== 'OK' || !response.routes.length) {
        resolve({ tolls: [], totalToll: 0, hasTollFreeAlternative: false });
        return;
      }

      // Check primary route for tolls
      const primaryRoute = response.routes[0];
      const primaryTolls = detectTollsInRoute(primaryRoute, pickupTime);

      // Check if there's a toll-free alternative
      let tollFreeRoute = null;
      let hasTollFreeAlternative = false;

      for (let i = 1; i < response.routes.length; i++) {
        const altTolls = detectTollsInRoute(response.routes[i], pickupTime);
        if (altTolls.length === 0) {
          tollFreeRoute = response.routes[i];
          hasTollFreeAlternative = true;
          break;
        }
      }

      // Get toll-free route details
      let tollFreeDetails = null;
      if (tollFreeRoute) {
        const leg = tollFreeRoute.legs[0];
        tollFreeDetails = {
          distance: Math.round(leg.distance.value / 100) / 10,
          duration: Math.round((leg.duration_in_traffic?.value || leg.duration.value) / 60),
        };
      }

      const totalToll = primaryTolls.reduce((sum, t) => sum + t.cost, 0);

      resolve({
        tolls: primaryTolls,
        totalToll: Math.round(totalToll * 100) / 100,
        hasTollFreeAlternative,
        tollFreeDetails,
        routeSummary: primaryRoute.summary,
      });
    });
  });
}
//=========================================================
// Roads tolled by DISTANCE (entry/exit dependent) — our flat figure is an ESTIMATE only.
// Exact amounts require a real toll-pricing source (e.g. Google Routes API tollInfo).
const DISTANCE_BASED_TOLLS = new Set([
  'm2', 'm4', 'm5_east', 'm5_southwest', 'm7', 'm8', 'm4_m5_link', 'northconnex', 'lane_cove_tunnel',
]);

// WestConnex / linked-motorway network. In reality this tolls as ONE capped journey,
// so we collapse multiple detections into a single estimated charge rather than summing.
const WESTCONNEX_GROUP = new Set(['m4', 'm5_east', 'm5_southwest', 'm8', 'm4_m5_link']);

// Word-boundary keyword patterns matched against the route's turn-by-turn instructions.
// (Primary signal — far more reliable than a single coordinate + large radius.)
const TOLL_KEYWORDS = {
  harbour_bridge: [/\bharbou?r bridge\b/, /\bbradfield (hwy|highway)\b/],
  harbour_tunnel: [/\b(sydney )?harbou?r tunnel\b/],
  eastern_distributor: [/\beastern distributor\b/],
  cross_city_tunnel: [/\bcross city tunnel\b/],
  lane_cove_tunnel: [/\blane cove tunnel\b/],
  m2: [/\bm2\b/, /\bhills m2\b/],
  m4: [/\bm4\b/, /\bwestconnex m4\b/],
  m5_east: [/\bm5 east\b/],
  m5_southwest: [/\bm5 south[- ]?west\b/],
  m7: [/\bm7\b/, /\bwestlink\b/],
  m8: [/\bm8\b/],
  m4_m5_link: [/\bm4[- ]?m5\b/, /\brozelle\b/],
  northconnex: [/\bnorthconnex\b/],
};

// Proximity-only detections (no road name in the instructions) must be VERY close,
// so we don't charge tolls for routes that merely pass near a toll point.
const PROXIMITY_ONLY_MAX_M = 350;
// Window (around the toll point) used only to infer direction of travel.
const DIRECTION_ZONE_M = 1200;

function routeInstructionsText(route) {
  const parts = [route.summary || ''];
  for (const leg of route.legs || []) {
    for (const step of leg.steps || []) {
      const html = step.instructions || step.html_instructions || '';
      parts.push(String(html).replace(/<[^>]*>/g, ' '));
    }
  }
  return parts.join(' ').toLowerCase().replace(/\s+/g, ' ');
}

function detectTollsInRoute(route, pickupTime) {
  const path = route.overview_path || [];
  const points = path.map((p) => ({ lat: p.lat(), lng: p.lng() }));
  const text = routeInstructionsText(route);

  // Phase 1 — candidates by NAME (primary) or TIGHT proximity (secondary)
  const candidates = [];
  for (const toll of NSW_TOLLS) {
    let closestDist = Infinity;
    let firstIdx = -1, lastIdx = -1;
    for (let i = 0; i < points.length; i++) {
      const dist = haversineDistance(points[i].lat, points[i].lng, toll.coordinates.lat, toll.coordinates.lng);
      if (dist < closestDist) closestDist = dist;
      if (dist < DIRECTION_ZONE_M) { if (firstIdx === -1) firstIdx = i; lastIdx = i; }
    }
    const nameMatch = (TOLL_KEYWORDS[toll.id] || []).some((re) => re.test(text));
    const proximityMatch = closestDist <= PROXIMITY_ONLY_MAX_M;
    if (!nameMatch && !proximityMatch) continue;

    // Infer direction of travel through the toll zone
    let travelDirection = null;
    if (firstIdx !== -1 && points.length >= 2) {
      const beforeIdx = Math.max(0, firstIdx - 2);
      const afterIdx = Math.min(points.length - 1, lastIdx + 2);
      if (beforeIdx !== afterIdx) {
        const dLat = points[afterIdx].lat - points[beforeIdx].lat;
        const dLng = points[afterIdx].lng - points[beforeIdx].lng;
        travelDirection = Math.abs(dLat) >= Math.abs(dLng)
          ? (dLat < 0 ? 'southbound' : 'northbound')
          : (dLng < 0 ? 'westbound' : 'eastbound');
      }
    }
    // Directional toll filter — only charge when travelling in the tolled direction
    if (toll.direction && toll.direction !== 'both') {
      if (!travelDirection || toll.direction !== travelDirection) continue;
    }

    candidates.push({ toll, closestDist });
  }

  // Phase 2 — Harbour Bridge vs Tunnel are alternative crossings: keep the closer one
  const bridgeIdx = candidates.findIndex((c) => c.toll.id === 'harbour_bridge');
  const tunnelIdx = candidates.findIndex((c) => c.toll.id === 'harbour_tunnel');
  if (bridgeIdx !== -1 && tunnelIdx !== -1) {
    const removeIdx = candidates[bridgeIdx].closestDist <= candidates[tunnelIdx].closestDist ? tunnelIdx : bridgeIdx;
    candidates.splice(removeIdx, 1);
  }

  // Phase 3 — build final list (correct arg order for peak/weekend; mark estimates)
  const detectedTolls = [];
  let collapsedWestConnex = null;
  for (const c of candidates) {
    if (WESTCONNEX_GROUP.has(c.toll.id)) {
      // Collapse the network to ONE estimated charge = highest detected segment rate
      const rate = getTollRate(c.toll, pickupTime);
      if (!collapsedWestConnex || rate > collapsedWestConnex.cost) {
        collapsedWestConnex = {
          id: 'westconnex_network',
          name: 'WestConnex network',
          cost: rate,
          isPeak: isTollPeakTime(pickupTime, c.toll),
          isWeekend: isWeekend(pickupTime),
          estimate: true,
        };
      }
      continue;
    }
    detectedTolls.push({
      id: c.toll.id,
      name: c.toll.name,
      cost: getTollRate(c.toll, pickupTime),
      isPeak: isTollPeakTime(pickupTime, c.toll),
      isWeekend: isWeekend(pickupTime),
      estimate: DISTANCE_BASED_TOLLS.has(c.toll.id),
    });
  }
  if (collapsedWestConnex) detectedTolls.push(collapsedWestConnex);

  return detectedTolls;
}

// ═══════════════ TOLL POLICY ═══════════════
export const TOLL_POLICY = {
  // Rider sees estimated tolls before booking
  SHOW_BEFORE_BOOKING: true,
  // If driver uses a different toll road not in the estimate
  DRIVER_REROUTE_TO_TOLL: 'driver_pays', // rider only pays pre-estimated toll
  // If driver avoids estimated toll road
  DRIVER_AVOIDS_TOLL: 'refund_wallet', // rider gets toll refunded as wallet credit
  // Rider can request toll-free route
  TOLL_FREE_OPTION: true,
  // Toll disputes
  DISPUTE_WINDOW_HOURS: 48, // rider can dispute toll charges within 48 hours
};

export { NSW_TOLLS, detectTollsInRoute };
export default { detectTollsOnRoute, TOLL_POLICY, NSW_TOLLS, detectTollsInRoute };